import SellerBoxLogo from '@/assets/icons/SellerboxLogo.svg?react';
import { cn } from '@/utils/tailwind';
import { useState } from 'react';
import { SigninEmailForm } from './signin-email-form';
import { SigninPhoneForm } from './signin-phone-form';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';
import { motion } from 'framer-motion';
import { useLogEvent } from '@/hooks/use-log-event';
import { GA_EVENT_NAMES, GA_ROUTES } from '@/constants/ga';

export const SigninContainer = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<'email' | 'phone'>('email');

  const { logEvent } = useLogEvent();

  return (
    <div className="flex w-[480px] flex-col items-center gap-8 rounded-[20px] bg-white p-10 text-center max-md:p-5">
      <div className="flex flex-col items-center gap-4">
        <SellerBoxLogo />
        <div className="text-gr-700 Title3S18">
          마켓마다 로그인 없이
          <br />
          나의 모든 데이터를 한번에 조회하세요
        </div>
      </div>

      <div className="w-full space-y-3">
        <div className="relative flex w-full overflow-hidden rounded-md bg-gr-200 p-[5px] text-gr-800 Body4S14">
          {/* 이동하는 흰색 배경 */}
          <motion.div
            className="absolute left-[5px] top-[5px] h-10 w-[calc(50%-5px)] rounded-[10px] bg-white shadow-sm"
            animate={{
              x: tab === 'email' ? 0 : '100%',
            }}
            transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30,
            }}
          />
          <button
            className={cn(
              'relative z-10 h-10 flex-1 rounded-[10px] text-gr-800 Body1S16 max-md:Body4S14',
            )}
            onClick={() => {
              setTab('email');
              logEvent({
                eventName: GA_EVENT_NAMES.login.tabSelected.email,
                pageTitle: GA_ROUTES.login,
              });
            }}
          >
            이메일 로그인
          </button>
          <button
            className={cn(
              'relative z-10 h-10 flex-1 rounded-[10px] text-gr-800 Body1S16 max-md:Body4S14',
            )}
            onClick={() => {
              setTab('phone');
              logEvent({
                eventName: GA_EVENT_NAMES.login.tabSelected.phone,
                pageTitle: GA_ROUTES.login,
              });
            }}
          >
            휴대폰 번호 로그인
          </button>
        </div>

        {tab === 'email' && <SigninEmailForm />}
        {tab === 'phone' && <SigninPhoneForm />}
      </div>

      <div className="flex items-center gap-2">
        <div className="text-gr-600 Body5M14">아직 셀러박스 회원이 아니신가요?</div>
        <button
          className="flex items-center gap-1 text-gr-700 Body5M14"
          onClick={() => {
            logEvent({ eventName: GA_EVENT_NAMES.login.toSignup, pageTitle: GA_ROUTES.login });
            navigate(ROUTES.signup);
          }}
        >
          회원가입
          <ChevronRightIcon width={16} height={16} />
        </button>
      </div>
    </div>
  );
};
